import '../../../stylesheets/nav/nav.css'
import React from 'react';
import { Link } from 'react-router-dom'
import ProfilePopover from '../shared/ProfilePopover.js'

const Hamburger = ({ currentPath, isActive, subscription, paymentMethod }) => {
    const [isMenuOpen, setIsMenuOpen] = React.useState(false);

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    const closeMenu = () => {
        setIsMenuOpen(false);
    };

    //future improvements -> have the navbar <Link/> eleements be in a loop over so we can just edits the array of objects in a central location more easily
    return (
        <>
            {/*====== Siblings Inside Mobile Nav Container ======*/}
            
            {/* 
            Sibling 1 of 3: Place Holder to Take Up First Column
             Allowing the Hamburger to Naturally Be The Middle Sibling for Parent Container With Middle Column Tagged 'auto' to push to middle in: display: grid; grid-template-columns: 1fr auto 1fr; */}
            <div></div>
            
            {/* Sibling 2 of 3: Mobile hamburger button wrapper (flex container centers its children inside column 2) */}
            <div className="hamburger-navbar-nav">
                <button
                    className="navbar-hamburger"
                    onClick={toggleMenu}
                    aria-label="Toggle navigation menu"
                >
                    <span className="hamburger-line"></span>
                    <span className="hamburger-line"></span>
                    <span className="hamburger-line"></span>
                </button>
            </div>
            
            {/* Sibling 3 of 3: Column three with child prop justify-self: end;*/}            
            <div className="desktop-navbar-profile">
                <ProfilePopover
                    subscription={subscription}
                    paymentMethod={paymentMethod}
                />
            </div>

            {/* ====== Mobile Navbar Dropdown Nav Menu on Hamburger Click ======*/}
            <div className={`tabletmobile-navbar-menu ${isMenuOpen ? 'tabletmobile-navbar-menu-open' : ''}`}>
                <div className="tabletmobile-navbar-item">
                    <Link 
                        to="/authguard/dashboards/public-comparables" 
                        className={`tabletmobile-navbar-link ${isActive('/authguard/dashboards/public-comparables') ? 'active' : ''}`}
                        onClick={closeMenu}
                    >
                        <div className="tabletmobile-navbar-card-content">
                            <div className="tabletmobile-navbar-card-text">
                                <div className="tabletmobile-navbar-card-title">PUBLIC COMPARABLES</div>
                                <div className="tabletmobile-navbar-card-desc">Benchmark Public Companies</div>
                            </div>
                            <div className="tabletmobile-navbar-card-icon">
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                                    <rect x="3" y="4" width="4" height="16" fill="currentColor" opacity="0.6"/>
                                    <rect x="8" y="8" width="4" height="12" fill="currentColor" opacity="0.8"/>
                                    <rect x="13" y="6" width="4" height="14" fill="currentColor"/>
                                    <rect x="18" y="10" width="3" height="10" fill="currentColor" opacity="0.7"/>
                                </svg>
                            </div>
                        </div>
                    </Link>
                </div>
                <div className="tabletmobile-navbar-item">
                    <Link 
                        to="/authguard/dashboards/transaction-comps" 
                        className={`tabletmobile-navbar-link ${isActive('/authguard/dashboards/transaction-comps') ? 'active' : ''}`}
                        onClick={closeMenu}
                    >
                        <div className="tabletmobile-navbar-card-content">
                            <div className="tabletmobile-navbar-card-text">
                                <div className="tabletmobile-navbar-card-title">TRANSACTION COMPS</div>
                                <div className="tabletmobile-navbar-card-desc">View M&A Values</div>
                            </div>
                            <div className="tabletmobile-navbar-card-icon">
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                                    <path d="M2 12C2 6.48 6.48 2 12 2s10 4.48 10 10-4.48 10-10 10S2 17.52 2 12z" fill="none" stroke="currentColor" strokeWidth="2"/>
                                    <path d="M12 6v6l4 2" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                                    <circle cx="18" cy="6" r="3" fill="currentColor" opacity="0.8"/>
                                    <circle cx="6" cy="18" r="2" fill="currentColor" opacity="0.6"/>
                                </svg>
                            </div>
                        </div>
                    </Link>
                </div>
                <div className="tabletmobile-navbar-item">
                    <Link 
                        to="/authguard/dashboards/football-field" 
                        className={`tabletmobile-navbar-link ${isActive('/authguard/dashboards/football-field') ? 'active' : ''}`}
                        onClick={closeMenu}
                    >
                        <div className="tabletmobile-navbar-card-content">
                            <div className="tabletmobile-navbar-card-text">
                                <div className="tabletmobile-navbar-card-title">Football Field</div>
                                <div className="tabletmobile-navbar-card-desc">Synthesize</div>
                            </div>
                            <div className="tabletmobile-navbar-card-icon">
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                                    <rect x="4" y="3" width="16" height="18" rx="2" stroke="currentColor" strokeWidth="2" fill="none"/>
                                    <path d="M8 7h8M8 11h6M8 15h4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
                                    <circle cx="16" cy="11" r="1.5" fill="currentColor" opacity="0.8"/>
                                    <path d="M6 19l2-2 2 2" fill="currentColor" opacity="0.6"/>
                                </svg>
                            </div>
                        </div>
                    </Link>
                </div>
                <div className="tabletmobile-navbar-item">
                    <Link 
                        to="/authguard/dashboards/leaderboard" 
                        className={`tabletmobile-navbar-link ${isActive('/authguard/dashboards/leaderboard') ? 'active' : ''}`}
                        onClick={closeMenu}
                    >
                        <div className="tabletmobile-navbar-card-content">
                            <div className="tabletmobile-navbar-card-text">
                                <div className="tabletmobile-navbar-card-title">MOVERS LEADERBOARD</div>
                                <div className="tabletmobile-navbar-card-desc">Surface Largest Price Moves</div>
                            </div>
                            <div className="tabletmobile-navbar-card-icon">
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                                    <rect x="3" y="13" width="4" height="8" fill="currentColor" opacity="0.6"/>
                                    <rect x="10" y="9" width="4" height="12" fill="currentColor" opacity="0.8"/>
                                    <rect x="17" y="4" width="4" height="17" fill="currentColor"/>
                                    <path d="M4 8l5-3 4 2 6-4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" opacity="0.5"/>
                                </svg>
                            </div>
                        </div>
                    </Link>
                </div>
            </div>
            
        </>
    );
};

export default Hamburger
